import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { UserBehaviorRisksAppDataProviderFactory } from '../factory/UserBehaviorRisksAppDataProviderFactory';
import { UserBehaviorRisksAppBaseDataProvider } from '../dataProvider/UserBehaviorRisksAppBaseDataProvider';
import { UserBehaviorRisksAppWebComponentSchema } from '../types';

export class UserBehaviorRisksAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: UserBehaviorRisksAppDataProviderFactory;
  public dataProvider: UserBehaviorRisksAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new UserBehaviorRisksAppDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<UserBehaviorRisksAppWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
